import type { VillageSummary217 } from '../domain/village217';

function isVillageSummary217(value: unknown): value is VillageSummary217 {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<VillageSummary217>;
  return candidate.version === '2.17'
    && typeof candidate.iglooStage === 'number'
    && typeof candidate.familySignalsCompleted === 'number'
    && Boolean(candidate.monthlyStory && typeof candidate.monthlyStory === 'object')
    && Boolean(candidate.visual && typeof candidate.visual === 'object')
    && Array.isArray(candidate.achievements);
}

export async function fetchVillageSummary217(region: string, signal?: AbortSignal): Promise<VillageSummary217> {
  const query = new URLSearchParams({ region });
  const response = await fetch(`/api/village-summary?${query.toString()}`, {
    headers: { Accept: 'application/json' },
    credentials: 'include',
    signal,
  });
  if (!response.ok) throw new Error(`VILLAGE_SUMMARY_${response.status}`);
  const payload: unknown = await response.json();
  if (!isVillageSummary217(payload)) throw new Error('VILLAGE_SUMMARY_INVALID');
  return payload;
}
